import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';
import Checkout from './Checkout.vue';
import { Button } from 'streamlabs-beaker';
import { EUserFlag } from '@/helpers/user';
import UserApi from '@/apis/user-api';

@Component({
  components: {
    Checkout,
    SButton: Button,
  },
})
export default class CheckoutPage extends Base {
  async skip() {
    await this.removeUserFlag(EUserFlag.showOnboarding);
    UserApi.removeShowOnboardingFlag();

    this.$router.push('/projects');
  }
}
